import { render, staticRenderFns } from "./subsidiaryDetail.vue?vue&type=template&id=bf37ee94&scoped=true&"
import script from "./subsidiaryDetail.vue?vue&type=script&lang=js&"
export * from "./subsidiaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./subsidiaryDetail.vue?vue&type=style&index=0&id=bf37ee94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf37ee94",
  null
  
)

export default component.exports